import React, { useRef } from "react";
import EventRow from "../EventRow/EventRow";
import { SchoolOutlined } from "@toddle-edu/ds-icons";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
} from "../../modules/Utils";
import { connect } from "react-redux";
import { useI18n } from "Hooks";
import { TextInput } from "@toddle-edu/ds-web";
import classes from "./Location.scss";
import PropTypes from "prop-types";
import classNames from "classnames";
import _ from "lodash";

const Location = props => {
  const {
    variant,
    eventModalV2,
    updateEventModalV2,
    locationClass = "",
    testId,
  } = props;
  const { t } = useI18n(["calendar"]);
  const setEventLocation = setValue("location", updateEventModalV2);

  const debouncedSetEventLocation = useRef(
    _.debounce(value => {
      setEventLocation(value);
    }, 300)
  );
  const onChange = e => {
    debouncedSetEventLocation.current(e?.target?.value);
  };
  return (
    <EventRow
      label="common:location"
      icon={<SchoolOutlined variant="subtle" />}
      renderComponent={() => (
        <div className={classNames(classes.container, locationClass)}>
          <TextInput
            onChange={onChange}
            variant={variant}
            placeholder={t("calendar:add_location")}
            defaultValue={eventModalV2?.location || ""}
            classNames={classes.textInput}
            testId={`${testId}-location`}
          />
        </div>
      )}
    />
  );
};

Location.defaultProps = {
  variant: "plain",
  eventModalV2: {},
  updateEventModalV2: () => {},
};
Location.propTypes = {
  variant: PropTypes.oneOf(["plain", "outlined"]),
  updateEventModalV2: PropTypes.func,
  eventModalV2: PropTypes.object,
};
export default connect(mapStateToProps, mapActionCreators)(Location);
